import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { CellFloatCustom, CellIntCustom, CellLeft, TableSubSimple } from 'motion-components';
import { useTranslation } from 'react-i18next';

export const CellIntNegativeRed = (_a) => {
  var value = _a.cell.value;
  if (value === null) return <div></div>;
  else if (value < 0) return <div className="text-danger">{CellIntCustom(10)(_a)}</div>;
  else return <div>{CellIntCustom(10)(_a)}</div>;
};

export const CellFloatNegativeRed = (_a) => {
  var value = _a.cell.value;

  if (value === null) return <div></div>;
  else if (value < 0) return <div className="text-danger">{CellFloatCustom(12, 2)(_a)}</div>;
  else return <div>{CellFloatCustom(12, 2)(_a)}</div>;
};

const gqlGetQuery = gql`
  query getWastereceptionpointTransactionsSums(
    $startDate: DateTime
    $endDate: DateTime
    $materialId: Int
    $wastereceptionpointId: Int
  ) {
    getWastereceptionpointTransactionsSums(
      startDate: $startDate
      endDate: $endDate
      materialId: $materialId
      wastereceptionpointId: $wastereceptionpointId
    ) {
      data {
        materialId
        materialName
        startWeight
        inputWeight
        outputWeight
        endWeight
      }
      recordCount
    }
  }
`;

const AggrGrid = ({ data }) => {
  const { t } = useTranslation();
  console.log(data);

  const aggrColumns = [
    {
      Header: t('Απόβλητο'),
      accessor: 'materialName',
      Cell: CellLeft,
      width: '100',
    },
    {
      Header: t('Αρχικά Κιλά'),
      accessor: 'startWeight',
      Cell: CellFloatNegativeRed,
      width: '100',
    },
    {
      Header: t('Εισερχόμενα Κιλά'),
      accessor: 'inputWeight',
      Cell: CellFloatNegativeRed,
      width: '100',
    },
    {
      Header: t('Εξερχόμενα Κιλά'),
      accessor: 'outputWeight',
      Cell: CellFloatNegativeRed,
      width: '100',
    },
    {
      Header: t('Τελικά Κιλά'),
      accessor: 'endWeight',
      Cell: CellFloatNegativeRed,
      width: '100',
    },
  ];

  return <TableSubSimple columns={aggrColumns} data={data} />;
};
/* ------------------------ Page ----------------------------- */
export const StockTransactionsAggregateSection = ({ filters }) => {
  const { t } = useTranslation();
  // const startDate = startOfDay(iStartDate);
  // const endDate = endOfDay(iEndDate);

  const {
    loading,
    data: rawData,
    error,
    refetch,
  } = useQuery(gqlGetQuery, {
    variables: {
      startDate: filters.startDate,
      endDate: filters.endDate,
      materialId: filters.materialId,
      wastereceptionpointId: filters.wastereceptionpointId,
    },
    fetchPolicy: 'network-only',
  });
  const data = rawData?.getWastereceptionpointTransactionsSums?.data;

  return (
    <div className="mt-1 mb-1">
      <h5>{t('Αθροίσματα Κινήσεων Αποθηκών')}</h5>
      {loading && (
        <Spinner className="m-4 text-primary" animation="border" role="status" size="sm" />
      )}
      {data ? <AggrGrid data={data} /> : <div style={{ minHeight: '120px' }}></div>}
    </div>
  );
};
